"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2258],{

/***/ 24677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BottomDrawer_BottomDrawer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useDelayedUnmount.ts

/**
 * Use this hook when you want to animate something when it appears on the screen (e.g. when some prop set to true)
 * but when its not on the screen you want it to be fully unmounted and not just hidden or height 0.
 * This is especially useful when you have a table of 100s rows and each row has expandable element that appears on click.
 * If you just set the expanding animation while keeping inactive elements mounted all those 100 elements will load the DOM,
 * and if they all receive updates via props you're looking at 100 DOM updates for hidden elements.
 * This hook "shows" element immediately when the isMounted is true
 * but keeps element mounted for delayTime to let unmounting animation happen, after which you unmount element completely.
 * delayTime should be the same as animation time in most cases.
 */ var useDelayedUnmount = function useDelayedUnmount(isMounted, delayTime) {
    var ref = (0,react.useState)(false), shouldRender = ref[0], setShouldRender = ref[1];
    (0,react.useEffect)(function() {
        var timeoutId;
        if (isMounted && !shouldRender) {
            setShouldRender(true);
        } else if (!isMounted && shouldRender) {
            timeoutId = setTimeout(function() {
                return setShouldRender(false);
            }, delayTime);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        isMounted,
        delayTime,
        shouldRender
    ]);
    return shouldRender;
};
/* harmony default export */ var hooks_useDelayedUnmount = (useDelayedUnmount);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useOnClickOutside.ts
var useOnClickOutside = __webpack_require__(93788);
// EXTERNAL MODULE: ./packages/uikit/src/util/getPortalRoot.ts
var getPortalRoot = __webpack_require__(70032);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Overlay/Overlay.tsx
var Overlay = __webpack_require__(72881);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(81641);
// EXTERNAL MODULE: ./packages/uikit/src/components/BottomDrawer/styles.ts
var styles = __webpack_require__(86258);
;// CONCATENATED MODULE: ./packages/uikit/src/components/BottomDrawer/BottomDrawer.tsx












var BottomDrawer = function BottomDrawer(param) {
    var content = param.content, isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var ref = (0,react.useRef)(null);
    var shouldRender = hooks_useDelayedUnmount(isOpen, 350);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    (0,useOnClickOutside/* default */.Z)(ref === null || ref === void 0 ? void 0 : ref.current, (0,react.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]));
    if (!shouldRender || !isMobile) {
        return null;
    }
    var portal = (0,getPortalRoot/* default */.Z)();
    if (portal) return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
                isUnmounting: !isOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* DrawerContainer */.qt, {
                ref: ref,
                isUnmounting: !isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        position: "absolute",
                        right: "16px",
                        top: "0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            onClick: function onClick() {
                                return setIsOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        })
                    }),
                    content
                ]
            })
        ]
    }), portal);
    return null;
};
/* harmony default export */ var BottomDrawer_BottomDrawer = (BottomDrawer);


/***/ }),

/***/ 40589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16zM8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35a.501.501 0 00-.7 0z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 63771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 78593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7V18C3 19.1046 3.89543 20 5 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H5V7Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 17H7C6.44772 17 6 16.5523 6 16V12C6 11.4477 6.44772 11 7 11H10V10C10 9.44772 10.4477 9 11 9H14V7C14 6.44772 14.4477 6 15 6H19C19.5523 6 20 6.44772 20 7V16C20 16.5523 19.5523 17 19 17ZM16 8H18V15H16V8ZM12 15H14V11H12V15ZM10 13H8V15H10V13Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 53055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 23 22"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M21.5 1l-20 20",
                strokeWidth: 2,
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.033 19H19.5a1 1 0 100-2H9.033l-2 2zm3-3H18.5a1 1 0 001-1V6.533l-2 2V14h-2v-3.467l-2 2V14h-1.467l-2 2zm.936-8H10.5a1 1 0 00-1 1v.469L10.969 8zm-2 2L5.5 13.469V11a1 1 0 011-1h2.469zM4.5 14.469l-2 2V6a1 1 0 012 0v8.469z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 7216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85937);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var components_SearchModal_ImportToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97139);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);




var ImportTokenWarningModal = function(param) {
    var tokens = param.tokens, onDismiss = param.onDismiss, onCancel = param.onCancel;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Import Token"),
        onDismiss: function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            onCancel();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            maxWidth: "380px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SearchModal_ImportToken__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                tokens: tokens,
                handleCurrencySelect: onDismiss
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImportTokenWarningModal);


/***/ }),

/***/ 11372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10427);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56974);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 58485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10427);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14141);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89663);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(78593);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(40589);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(45203);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40696);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(66806);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(921);
/* harmony import */ var state_user_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9372);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21190);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7312);
/* harmony import */ var utils_getLpAddress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80462);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69077);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36963);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37930);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 1%;\n  height: 530px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  bottom: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);\n  .icon-up-down {\n    display: none;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .icon-down {\n      display: none;\n      fill: white;\n    }\n    .icon-up {\n      display: none;\n      fill: white;\n    }\n    .icon-up-down {\n      display: block;\n      fill: white;\n    }\n    .icon-history {\n      display: block;\n      fill: white;\n    }\n  }\n  margin-right: 3px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);\n  &:hover {\n    background-color: ",
        ";\n    .icon-chart {\n      fill: white;\n    }\n  }\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


// import useTheme from 'hooks/useTheme'


// import BnbWbnbNotice from './BnbWbnbNotice'
// import { BNB_ADDRESS } from './constants'
// import PriceChart from './PriceChart'
// import RefreshIcon from 'components/Svg/RefreshIcon'




// import { BUSD, USDC } from '@pancakeswap/tokens'




// import TrendingContainer from '../Trending/TrendingContainer'
// import { current } from '@reduxjs/toolkit'
var fadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .keyframes */ .F4)(_templateObject());
var ChartFrame = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    componentId: "sc-51d5a08f-0"
})(_templateObject1(), function(props) {
    return props.Mobile ? "bottom: 0;" : null;
});
var ChartContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-51d5a08f-1"
})(_templateObject2());
var TrendContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-51d5a08f-2"
})(_templateObject3());
var SwitchContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-51d5a08f-3"
})(_templateObject4(), function(props) {
    return props.Mobile ? "bottom: 150px" : "bottom: 38px;";
}, function(props) {
    return props.Mobile ? "left: 35%;" : "left: 4px;";
});
var SwitchIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-51d5a08f-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var DexIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-51d5a08f-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var PriceChartContainer = function(param) {
    var inputCurrencyId = param.inputCurrencyId, inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, outputCurrencyId = param.outputCurrencyId, isChartExpanded = param.isChartExpanded, setIsChartExpanded = param.setIsChartExpanded, isChartDisplayed = param.isChartDisplayed, isMobile = param.isMobile, _isFullWidthContainer = param.isFullWidthContainer, isFullWidthContainer = _isFullWidthContainer === void 0 ? false : _isFullWidthContainer, currentSwapPrice = param.currentSwapPrice, currentChainId = param.currentChainId;
    var chartURL = function chartURL() {
        var trades = isShowTrades === true ? "1" : "0";
        var chainName = "dogechain";
        var url = "https://dexscreener.com/shibarium/".concat(isPairReversed ? token0Address : token1Address, "?embed=1&theme=dark&trades=").concat(trades, "&info=0");
        if (currentChainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.SHIBARIUM */ .a_.SHIBARIUM) {
            isDogechain = false;
            chainName = "shibarium";
            // eslint-disable-next-line no-lonely-if
            if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.DEXSCREENER */ .UU.DEXSCREENER) {
                url = "https://dexscreener.com/".concat(chainName, "/").concat(pairExists ? pairAddress : isPairReversed ? token0Address : token1Address, "?embed=1&theme=dark&trades=").concat(trades, "&info=0");
            } else if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.WEB3SHARDS */ .UU.WEB3SHARDS) {
                url = "https://web3shards.io/chart?chain=shibarium&theme=dark&mode=compact&stats=false&apiKey=4aa285fe-7077-4d62-b9a9-ca42e1c5ff91&token=".concat(isPairReversed ? token0Address : token1Address, "&socketId=b048b37f-fcba-4f27-833e-e871abb32474");
            } else if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.GECKOTERMINAL */ .UU.GECKOTERMINAL) {
                // url = `https://www.geckoterminal.com/${chainName}/pools/${isPairReversed ? token0Address : token1Address}?embed=1&info=0&swaps=${trades}`
                url = "https://dexscreener.com/".concat(chainName, "/").concat(pairExists ? pairAddress : isPairReversed ? token0Address : token1Address, "?embed=1&theme=dark&trades=").concat(trades, "&info=0");
            }
        } else {
            isDogechain = true;
            chainName = "dogechain";
            // console.log(`Dogechain Chart: ${chartView}`);
            if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.DEXSCREENER */ .UU.DEXSCREENER) {
                url = "https://dexscreener.com/".concat(chainName, "/").concat(pairExists ? pairAddress !== null && pairAddress !== void 0 ? pairAddress : isPairReversed ? token0Address : token1Address : isPairReversed ? token0Address : token1Address, "?embed=1&theme=dark&trades=").concat(trades, "&info=0");
            } else if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.WEB3SHARDS */ .UU.WEB3SHARDS) {
                url = "https://www.geckoterminal.com/".concat(chainName, "/pools/").concat(pairExists ? pairAddress !== null && pairAddress !== void 0 ? pairAddress : isPairReversed ? token0Address : token1Address : isPairReversed ? token0Address : token1Address, "?embed=1&info=0&swaps=").concat(trades);
            } else if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.GECKOTERMINAL */ .UU.GECKOTERMINAL) {
                // url = `https://www.geckoterminal.com/${chainName}/pools/${isPairReversed ? token0Address : token1Address}?embed=1&info=0&swaps=${trades}`
                url = "https://dexscreener.com/".concat(chainName, "/").concat(pairExists ? pairAddress !== null && pairAddress !== void 0 ? pairAddress : isPairReversed ? token0Address : token1Address : isPairReversed ? token0Address : token1Address, "?embed=1&theme=dark&trades=").concat(trades, "&info=0");
            } else {
                url = "https://dexscreener.com/".concat(chainName, "/").concat(pairExists ? pairAddress !== null && pairAddress !== void 0 ? pairAddress : isPairReversed ? token0Address : token1Address : isPairReversed ? token0Address : token1Address, "?embed=1&theme=dark&trades=").concat(trades, "&info=0");
            }
        }
        /* console.log(
      url,
      ' ',
      token1Address,
      ' ',
      token0Address,
      ' ',
      pairAddress,
      ' ',
      pairExists,
      ' ',
      isPairReversed,
      ' ',
      isShowTrades,
      ' ',
      chartView,
      ' ',
      currentChainId,
      ' ',
      chainName,
    ) */ return url;
    };
    var wnative = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .WNATIVE */ .FX[currentChainId];
    var token0Address = (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .getTokenAddress */ .D)(inputCurrencyId);
    var token1Address = (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .getTokenAddress */ .D)(outputCurrencyId);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isPairReversed = ref[0], setIsPairReversed = ref[1];
    var togglePairReversed = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return setIsPairReversed(function(prePairReversed) {
            return !prePairReversed;
        });
    }, []);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), isChart = ref1[0], setChart = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isShowTrades = ref2[0], setIsShowTrades = ref2[1];
    var toggleShowTrades = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return setIsShowTrades(function(preShowTrades) {
            return !preShowTrades;
        });
    }, []);
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,state_user_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useExchangeChartViewManager */ .OE)(), 2), chartView = ref3[0], setChartView = ref3[1];
    // const [pairExists, setPairExists] = useState(false)
    var provider = (0,wagmi__WEBPACK_IMPORTED_MODULE_12__/* .useProvider */ .yL)({
        chainId: currentChainId
    });
    var isNativePair = function(currency1, currency2) {
        return (currency1 === null || currency1 === void 0 ? void 0 : currency1.isNative) && (currency2 === null || currency2 === void 0 ? void 0 : currency2.wrapped.equals(wnative)) || (currency2 === null || currency2 === void 0 ? void 0 : currency2.isNative) && (currency1 === null || currency1 === void 0 ? void 0 : currency1.wrapped.equals(wnative));
    };
    var getPairAddress = function() {
        if (isNativePair(inputCurrency, outputCurrency)) return "0x39d34dC54e47ba6f4ABb500a1f4F0Ea9DFC7FeeD";
        return (0,utils_getLpAddress__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative) ? wnative : token0Address, (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.isNative) ? wnative : token1Address, currentChainId);
    };
    var pairAddress = getPairAddress();
    var pairContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_7__/* .usePairContract */ .t0)(pairAddress);
    var pairExists = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var reserves, reserve0, reserve1, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!pairContract) {
                        return [
                            2,
                            false
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        pairContract.connect(provider).getReserves()
                    ];
                case 2:
                    reserves = _state.sent();
                    if (!reserves) {
                        return [
                            2,
                            false
                        ];
                    }
                    reserve0 = reserves.reserve0, reserve1 = reserves.reserve1;
                    return [
                        2,
                        true
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        pairContract,
        provider
    ]);
    var incrementChart = function() {
        if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.DEXSCREENER */ .UU.DEXSCREENER) {
            setChart(0);
        } else if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.GECKOTERMINAL */ .UU.GECKOTERMINAL) {
            setChart(1);
        } else if (chartView === state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.WEB3SHARDS */ .UU.WEB3SHARDS) {
            if (currentChainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.DOGECHAIN */ .a_.DOGECHAIN) {
                setChart(1);
            } else {
                setChart(2);
            }
        }
        if (currentChainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.DOGECHAIN */ .a_.DOGECHAIN) {
            if (isChart === 1) {
                setChart(0);
            } else {
                setChart(isChart + 1);
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (isChart === 2) {
                setChart(0);
            } else {
                setChart(isChart + 1);
            }
        }
        switch(isChart){
            case 0:
                setChartView(state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.DEXSCREENER */ .UU.DEXSCREENER);
                break;
            case 1:
                setChartView(state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.GECKOTERMINAL */ .UU.GECKOTERMINAL);
                break;
            case 2:
                setChartView(state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.WEB3SHARDS */ .UU.WEB3SHARDS);
                break;
            default:
                setChartView(state_user_actions__WEBPACK_IMPORTED_MODULE_5__/* .ChartViewMode.DEXSCREENER */ .UU.DEXSCREENER);
        }
    };
    // const { isDark } = useTheme()
    if (!isChartDisplayed) {
        return null;
    }
    var isDogechain = false;
    if (currentChainId === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.DOGECHAIN */ .a_.DOGECHAIN) {
        isDogechain = true;
    }
    if (inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative) token0Address = wnative.address;
    if (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.isNative) token1Address = wnative.address;
    // const isBnbWbnb = token0Address === BNB_ADDRESS && token1Address === BNB_ADDRESS
    /* if (isBnbWbnb) {
    return <BnbWbnbNotice isDark={isDark} isChartExpanded={isChartExpanded} />
  } */ var frameHeight = "525px";
    if (isShowTrades) {
        frameHeight = "625px";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_15__/* .AnimatePresence */ .M, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                width: "100%",
                flexDirection: "column",
                justifyContent: "stretch",
                position: "relative",
                alignItems: "stretch",
                justifyItems: "flex-start",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ChartContainer, {
                    as: framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion.div */ .E.div,
                    layout: true,
                    initial: {
                        width: 0
                    },
                    animate: {
                        width: "100%"
                    },
                    exit: {
                        width: 0
                    },
                    transition: {
                        duration: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChartFrame, {
                            as: framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion.iframe */ .E.iframe,
                            initial: {
                                opacity: 0,
                                scale: 0.05
                            },
                            animate: {
                                opacity: 1,
                                scale: 1
                            },
                            exit: {
                                opacity: 0,
                                scale: 0.05
                            },
                            transition: {
                                opacity: {
                                    duration: 2,
                                    delay: 1
                                },
                                scale: {
                                    duration: 2,
                                    delay: 1.1
                                }
                            },
                            Mobile: isMobile,
                            className: "dexchart_iframe",
                            src: "".concat(chartURL()),
                            name: "web3-shards-chart",
                            height: isMobile ? "100%" : "".concat(frameHeight),
                            width: "100%",
                            title: "web3-shards-chart"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SwitchContainer, {
                            as: framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion.div */ .E.div,
                            layout: true,
                            initial: {
                                opacity: 0,
                                scale: 0.7
                            },
                            animate: {
                                opacity: 1,
                                scale: 1
                            },
                            exit: {
                                opacity: 0,
                                scale: 0
                            },
                            transition: {
                                opacity: {
                                    delay: 2,
                                    duration: 2.5
                                },
                                scale: {
                                    delay: 2,
                                    duration: 2
                                }
                            },
                            Mobile: isMobile,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DexIconButton, {
                                    variant: "light",
                                    scale: "sm",
                                    "aria-label": "Cycle Chart View",
                                    title: "Cycle Different Charts",
                                    onClick: function() {
                                        incrementChart();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        className: "icon-chart",
                                        color: "primary"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SwitchIconButton, {
                                    variant: "light",
                                    scale: "sm",
                                    "aria-label": "Chart Input or Output Token",
                                    title: "Cycle Different Charts",
                                    onClick: togglePairReversed,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            className: "icon-up-down",
                                            color: "primary"
                                        }),
                                        isPairReversed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            className: "icon-down",
                                            color: "primary"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            className: "icon-up",
                                            color: "primary"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwitchIconButton, {
                                    variant: "light",
                                    scale: "sm",
                                    "aria-label": "Toggle Show Trades",
                                    title: "Toggle Show Trades",
                                    onClick: toggleShowTrades,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        className: "icon-history",
                                        color: "primary"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/*
   <PriceChart
     token0Address={isPairReversed ? token1Address : token0Address}
     token1Address={isPairReversed ? token0Address : token1Address}
     inputCurrency={isPairReversed ? outputCurrency : inputCurrency}
     outputCurrency={isPairReversed ? inputCurrency : outputCurrency}
     onSwitchTokens={togglePairReversed}
     isDark={isDark}
     isChartExpanded={isChartExpanded}
     setIsChartExpanded={setIsChartExpanded}
     isMobile={isMobile}
     isFullWidthContainer={isFullWidthContainer}
     currentSwapPrice={currentSwapPrice}
   />
 */ /* harmony default export */ __webpack_exports__["Z"] = (PriceChartContainer);


/***/ })

}]);